import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Store, Search } from "lucide-react";
import { api } from "@/lib/api";
import { Section, Chip } from "@/components/ui-brand";

export default function Vidriera() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const cats = ["Diseño gráfico", "Desarrollo de software", "Marketing", "Gastronomía", "Consultoría", "Fotografía"];

  const load = () => api.get(`/public/vidriera?q=${q}&categoria=${cat}`).then((r) => setItems(r.data.items)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [cat]);

  return (
    <Section className="py-12">
      <Chip accent>Vidriera emprendedora</Chip>
      <h1 className="h-section text-3xl mt-3 mb-2">Productos y servicios de la comunidad</h1>
      <p className="text-[var(--brand-text-muted)] mb-6 max-w-2xl">Emprendedores/as egresados/as de la red. Contratá servicios puntuales directamente.</p>

      <div className="flex flex-wrap gap-3 mb-6 items-center">
        <div className="flex items-center gap-2 rounded-full border-2 border-[var(--brand-border)] px-4 py-2 flex-1 min-w-[220px]">
          <Search size={16} className="text-[var(--brand-text-muted)]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Buscar…" data-testid="vidriera-search"
            className="flex-1 text-sm outline-none" />
        </div>
        <div className="flex flex-wrap gap-2">
          <Chip onClick={() => setCat("")} active={cat === ""} testid="vidriera-cat-all">Todas</Chip>
          {cats.map((c) => <Chip key={c} onClick={() => setCat(c)} active={cat === c} testid={`vidriera-cat-${c}`}>{c}</Chip>)}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((e, i) => (
          <motion.div key={e.id} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 6) * 0.05 }}
            className="card-brand p-6" data-testid={`vidriera-item-${e.id}`}>
            <span className="w-11 h-11 rounded-2xl flex items-center justify-center text-white mb-3" style={{ background: "var(--brand-accent)" }}><Store size={20} /></span>
            <Chip>{e.categoria}</Chip>
            <p className="font-heading font-bold text-[var(--brand-primary)] mt-3">{e.nombre}</p>
            <p className="text-sm text-[var(--brand-text-muted)] mt-1 leading-relaxed">{e.descripcion}</p>
            <div className="flex flex-wrap gap-1.5 mt-3">{(e.skills_aplicadas || []).map((s) => <Chip key={s}>{s}</Chip>)}</div>
            <div className="mt-4 pt-3 border-t border-slate-100 text-sm">
              <span className="text-[var(--brand-text-muted)]">Por {e.egresado_nombre}</span>
              <div className="font-semibold text-[var(--brand-accent)] mt-1">{e.contacto}</div>
            </div>
          </motion.div>
        ))}
        {items.length === 0 && <p className="text-[var(--brand-text-muted)] col-span-full text-center py-10">No hay emprendimientos para mostrar.</p>}
      </div>
    </Section>
  );
}
